// extracted by mini-css-extract-plugin
export var avatar = "_ru-3";
export var avatarContainer = "_ru-2";
export var avatarSpacer = "_ru-5";
export var avatarSpacerContainer = "_ru-4";
export var avatarStackContainer = "_ru-1";
export var bubble = "_ru-0";
export var remainderBubble = "_ru-6";